/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Section_DisplayInputs */

const en_options_metrics_section_display = /** @type {(inputs: Options_Metrics_Section_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor List Display`)
};

const fr_options_metrics_section_display = /** @type {(inputs: Options_Metrics_Section_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor List Display`)
};

const de_options_metrics_section_display = /** @type {(inputs: Options_Metrics_Section_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor List Display`)
};

const it_options_metrics_section_display = /** @type {(inputs: Options_Metrics_Section_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor List Display`)
};

const ru_options_metrics_section_display = /** @type {(inputs: Options_Metrics_Section_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor List Display`)
};

const es_options_metrics_section_display = /** @type {(inputs: Options_Metrics_Section_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor List Display`)
};

const zh_cn2_options_metrics_section_display = /** @type {(inputs: Options_Metrics_Section_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor List Display`)
};

const ja_options_metrics_section_display = /** @type {(inputs: Options_Metrics_Section_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor List Display`)
};

const hi_options_metrics_section_display = /** @type {(inputs: Options_Metrics_Section_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor List Display`)
};

const pt_pt2_options_metrics_section_display = /** @type {(inputs: Options_Metrics_Section_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor List Display`)
};

/**
* | output |
* | --- |
* | "Editor List Display" |
*
* @param {Options_Metrics_Section_DisplayInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_section_display = /** @type {((inputs?: Options_Metrics_Section_DisplayInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Section_DisplayInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_metrics_section_display(inputs)
	if (locale === "de") return de_options_metrics_section_display(inputs)
	if (locale === "it") return it_options_metrics_section_display(inputs)
	if (locale === "ru") return ru_options_metrics_section_display(inputs)
	if (locale === "es") return es_options_metrics_section_display(inputs)
	if (locale === "zh-CN") return zh_cn2_options_metrics_section_display(inputs)
	if (locale === "ja") return ja_options_metrics_section_display(inputs)
	if (locale === "hi") return hi_options_metrics_section_display(inputs)
	if (locale === "pt-PT") return pt_pt2_options_metrics_section_display(inputs)
	return en_options_metrics_section_display(inputs)
});